export default {
    name: 'AppVersion',

    data() {
        return {
            version: null
        };
    },

    mounted() {
        this.version = this.$store.getters.getAppVersion;
    }
};
